import React from "react"
import { cn } from "../../lib/utils"

export const ShimmerButton = React.forwardRef(function ShimmerButton(
  { shimmerColor = "#ffffff", shimmerSize = "0.05em", shimmerDuration = "3s", borderRadius = "100px", background = "#173d2b", className, children, ...props },
  ref,
) {
  return (
    <button
      style={{ "--shimmer-color": shimmerColor, "--radius": borderRadius, "--speed": shimmerDuration, "--cut": shimmerSize, "--bg": background }}
      className={cn("group relative z-0 flex cursor-pointer items-center justify-center overflow-hidden border border-white/10 px-5 py-2.5 whitespace-nowrap text-white [border-radius:var(--radius)] [background:var(--bg)] transition-transform duration-300 active:translate-y-px", className)}
      ref={ref}
      {...props}
    >
      <span className="absolute inset-0 -z-30 overflow-visible blur-[2px]">
        <span className="animate-shimmer-slide absolute inset-0 aspect-square h-full">
          <span className="animate-spin-around absolute -inset-full [background:conic-gradient(from_225deg,transparent_0,var(--shimmer-color)_90deg,transparent_90deg)]" />
        </span>
      </span>
      {children}
      <span className="absolute inset-0 rounded-[inherit] shadow-[inset_0_-8px_10px_#ffffff1f] transition-shadow group-hover:shadow-[inset_0_-6px_10px_#ffffff3f]" />
      <span className="absolute inset-(--cut) -z-20 rounded-[inherit] [background:var(--bg)]" />
    </button>
  )
})
